import axiosTokenInstance from "services/api/backoffice";
import { MY_SALES_DETAILS, MY_SALES_DETAILS_ERROR } from "_models/redux/types";

// Action function
export const getMySalesDetails = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        const response = await axiosTokenInstance.get(
            `/api/callcenter/my-sales?date=${params.date}`
        );

        const { data, status } = response || {};

        dispatch({
            type: MY_SALES_DETAILS,
            payload: data || {},
            status: status || {},
            method: "get",
        });
    } catch (e) {
        dispatch({
            type: MY_SALES_DETAILS_ERROR,
            payload: e || {},
        });
    }
};
